module.exports = __webpack_public_path__ + "img/denis-casey.1c46fd71.jpg";